import { getCalcInputState } from "../../../../../utils/selectors";
import { joistSlice } from "./slice";

export const getJoistState = state => getCalcInputState(state)[joistSlice.name];